import { useCallback } from 'react';
import { useNotifications } from '@/features/notifications';
import { OpportunityDetails, Plan } from '@/features/opportunities/types';
import { useUpdateOpportunityMutation } from '../api';

export function useSavePlan(opportunity: OpportunityDetails) {

    const [opportunityMutation] = useUpdateOpportunityMutation();
    const { add } = useNotifications();

    return useCallback((newPlan: Plan) => {

        if (!opportunity) return;

        opportunityMutation({ id: opportunity.id, data: { plan: newPlan } })
            .unwrap()
            .then(() => {
                add({
                    id: new Date().toString(),
                    title: 'Plan updated',
                    description: `The opportunity plan has been successfully changed to "${newPlan}".`,
                });
            })
            .catch(() => {
                add({
                    id: new Date().toString(),
                    title: 'Error updating plan',
                    description: 'There was a problem updating the plan. Please try again later.',
                });
            });
    }, [opportunity, opportunityMutation, add])
}
